import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  cancelSubscription: {
    id: 'mac.licenses.cancel.subscription',
    defaultMessage: 'Cancel subscription',
  },
  cancelTrial: {
    id: 'mac.licenses.cancel.trial',
    defaultMessage: 'Cancel trial',
  },
  deactivatedEndedTrial: {
    id: 'mac.licenses.deactivated.trial.message',
    defaultMessage:
      'Deactivated - Your trial period has ended. If you wish to reactivate your instance, you will need to <convertLink>convert</convertLink> to a paid instance. You will be charged for the first monthly payment. Please <contactLink>contact us</contactLink> if you have any questions.',
  },
  deactivatedNoRenewalAction: {
    id: 'mac.licenses.deactivated.no.renewal.action',
    defaultMessage:
      'Deactivated - If you wish to reactivate your instance, please <contactLink>contact us</contactLink>.',
  },
  deactivatedProvidePayment: {
    id: 'mac.licenses.deactivated.provide.payment',
    defaultMessage:
      'Deactivated -  Please <paymentLink>provide valid payment details</paymentLink> to reactivate your instance. {br} If you have any questions, please <contactLink>contact us</contactLink>.',
  },
  deactivatedContactUs: {
    id: 'mac.licenses.deactivated.contact-us',
    defaultMessage:
      'Deactivated - If you have any questions, please <contactLink>contact us</contactLink>.',
  },
  inactive: {
    id: 'mac.licenses.inactive',
    defaultMessage: 'Inactive',
  },
  inactiveTooltip: {
    id: 'mac.licenses.inactive-tooltip',
    defaultMessage: 'This user has closed their account. We recommend you to replace this contact.',
  },
  active: {
    id: 'mac.licenses.active',
    defaultMessage: 'Active',
  },
  renewsOn: {
    id: 'mac.licenses.renews.on',
    defaultMessage: 'Renews On',
  },
  on: {
    id: 'mac.licenses.on',
    defaultMessage: 'On',
  },
  off: {
    id: 'mac.licenses.off',
    defaultMessage: 'Off',
  },
  turnAutoRenewOff: {
    id: 'mac.licenses.turn-auto-renew-off',
    defaultMessage: 'Turn Auto-Renew Off',
  },
  turnAutoRenewOn: {
    id: 'mac.licenses.turn-auto-renew-on',
    defaultMessage: 'Turn Auto-Renew On',
  },
  autoRenew: {
    id: 'mac.licenses.auto-renew',
    defaultMessage: 'Auto-Renew',
  },
  noAutoRenew: {
    id: 'mac.licenses.no-auto-renew.expired',
    defaultMessage: 'Auto-renew cannot be turned on for expired licenses',
  },
  cancelAutoRenewWarning: {
    id: 'mac.licenses.cancel-auto-renew.warning',
    defaultMessage:
      'For product {productDescription} with {senNumber} auto-renew will be turned off.',
  },
  cancelAutoRenewError: {
    id: 'mac.licenses.cancel-auto-renew.error',
    defaultMessage: 'Something went wrong. Please try again.',
  },
  cancelAutoRenewCancelButton: {
    id: 'mac.licenses.cancel-auto-renew.cancel-button',
    defaultMessage: "Don't turn auto-renew off",
  },
  cancelAutoRenewSubmitButton: {
    id: 'mac.licenses.cancel-auto-renew.submit-button',
    defaultMessage: 'Turn Auto-Renew Off',
  },
  missingPaymentDetailsWarning: {
    id: 'mac.licenses.missing-payment-details.warning',
    defaultMessage:
      'Missing payment details - your software maintenance will not be automatically renewed. {providePaymentDetailsLink} to ensure your software maintenance is renewed.',
  },
  automaticallyChargedInfo: {
    id: 'mac.licenses.automatically-charged-info',
    defaultMessage:
      'You will be automatically charged for your next renewal on {date} if you do not cancel auto-renew before this date.',
  },
  expirationDate: {
    id: 'mac.licenses.expiration.date',
    defaultMessage: 'Expiration Date',
  },
  paymentMethod: {
    id: 'mac.licenses.payment.method',
    defaultMessage: 'Payment Method',
  },
  editCreditCard: {
    id: 'mac.licenses.edit.credit.card',
    defaultMessage: 'Edit Credit Card',
  },
  providePaymentDetails: {
    id: 'mac.licenses.provide.payment.details',
    defaultMessage: 'Provide Payment Details',
  },
  trial: {
    id: 'mac.licenses.trial',
    defaultMessage: 'Trial',
  },
  subscription: {
    id: 'mac.licenses.subscription',
    defaultMessage: 'Subscription',
  },
  cancelCloudCubscription: {
    id: 'mac.licenses.cancel.cloud.cubscription',
    defaultMessage:
      'Canceling your Cloud subscription will deactivate the service and your instance will go offline. This cannot be undone.',
  },
  contactDetails: {
    id: 'review.contact-details',
    defaultMessage: 'Contact details',
  },
  technicalAddressOnInvoice: {
    id: 'mac.licenses.technical.address.on.invoice',
    defaultMessage:
      'The primary technical contact’s postal address is the address that will reflect in the invoice.',
  },
  technicalContacts: {
    id: 'mac.licenses.technical.contacts',
    defaultMessage: 'Technical Contacts',
  },
  technicalContact: {
    id: 'mac.licenses.technical.contact',
    defaultMessage: 'Technical Contact',
  },
  addBtn: {
    id: 'migrate.non-billing-user.search.add',
    defaultMessage: 'Add',
  },
  billingContacts: {
    id: 'mac.licenses.billing.contacts',
    defaultMessage: 'Billing Contacts',
  },
  name: {
    id: 'mac.lecenses.name',
    defaultMessage: 'Name',
  },
  SEN: {
    id: 'change.search.label.sen',
    defaultMessage: 'SEN',
  },
  senTooltip: {
    id: 'change.search.label.sen.title',
    defaultMessage: 'Support Entitlement Number',
  },
  URL: {
    id: 'mac.licenses.url',
    defaultMessage: 'URL',
  },
  addressDetails: {
    id: 'mac.licenses.address.details',
    defaultMessage: 'Address Details',
  },
  updateAddressDetails: {
    id: 'mac.licenses.update.address.details',
    defaultMessage: 'Update Address Details',
  },
  automaticallyChargedCardMessage: {
    id: 'mac.licenses.automatically.charged.card.message',
    defaultMessage:
      "Your credit card will be automatically charged for the following month's subscription on {endDate} if the subscription has not been cancelled before this date.",
  },
  notAutomaticallyRenewedProduct: {
    id: 'mac.licenses.not.automatically.renewed.product',
    defaultMessage: 'Your product subscription will not be automatically renewed. ',
  },
  contactToRenew: {
    id: 'mac.licenses.contact.to.renew',
    defaultMessage:
      'Please <contactLink>contact us</contactLink> if you wish to renew your subscription.',
  },
  updateEndDateMessage: {
    id: 'mac.licenses.update.endDate.message',
    defaultMessage:
      'This license is valid until {endDate}. To continue using your software past that date, you must purchase a renewal.',
  },
  organization: {
    id: 'mac.licenses.organization',
    defaultMessage: 'Organization',
  },
  licenseKey: {
    id: 'mac.licenses.license.key',
    defaultMessage: 'License Key',
  },
  licenseType: {
    id: 'mac.licenses.license.type',
    defaultMessage: 'License type',
  },
  viewLicense: {
    id: 'mac.licenses.view.license',
    defaultMessage: 'View License',
  },
  actions: {
    id: 'mac.licenses.actions',
    defaultMessage: 'Actions',
  },
  upgrade: {
    id: 'navigation.header.menu.upgrade',
    defaultMessage: 'Upgrade',
  },
  downloadWithDescription: {
    id: 'mac.licenses.download.with.description',
    defaultMessage: 'Download {description}',
  },
  viewDeveloperLicense: {
    id: 'mac.licenses.view.developer.license',
    defaultMessage: 'View Developer License',
  },
  archive: {
    id: 'mac.licenses.archive',
    defaultMessage: 'Archive',
  },
  history: {
    id: 'mac.licenses.history',
    defaultMessage: 'History',
  },
  lookupButton: {
    id: 'mac.orders.lookup.submit',
    defaultMessage: 'Submit',
  },
  lookupOrderNumberHint: {
    id: 'mac.orders.lookup.input.order.hint',
    defaultMessage: 'This number is prefixed with AT-',
  },
  lookupOrderNumberLabel: {
    id: 'mac.orders.lookup.input.order.label',
    defaultMessage: 'Order # (AT-)',
  },
  lookupOrderTotalLabel: {
    id: 'mac.orders.lookup.input.total.label',
    defaultMessage: 'Total',
  },
  lookupOrderTotalHint: {
    id: 'mac.orders.lookup.input.total.hint',
    defaultMessage: 'The order total',
  },
  lookupOrderEmailLabel: {
    id: 'mac.orders.lookup.input.email.label',
    defaultMessage: 'Email',
  },
  lookupOrderEmailHint: {
    id: 'mac.orders.lookup.input.email.hint',
    defaultMessage: "Billing or technical contact's email on the order",
  },
  selectButton: {
    id: 'mac.orders.evaluation.submit',
    defaultMessage: 'Select',
  },
  tooltipLine1: {
    id: 'mac.licenses.tooltip.line1',
    defaultMessage:
      'Technical contacts can raise support requests and have access to this license.',
  },
  tooltipLine2: {
    id: 'mac.licenses.tooltip.line2',
    defaultMessage:
      'Only primary contacts can access orders and invoices, and promote other users to be primary contact.',
  },
  tooltipLine3: {
    id: 'mac.licenses.tooltip.line3',
    defaultMessage: 'Non-primary contacts can promote themselves to be primary.',
  },
  primaryContact: {
    id: 'mac.licenses.primary.contact',
    defaultMessage: 'Primary',
  },
  makePrimary: {
    id: 'mac.licenses.make.primary',
    defaultMessage: 'Make Primary',
  },
  inactiveMakePrimary: {
    id: 'mac.licenses.inactive.make.primary',
    defaultMessage:
      "This user can't be made primary contact because their email domain doesn't match yours, or they are using a generic email domain. They are able to promote themselves if logged in.",
  },
  newContactEmail: {
    id: 'mac.licenses.new-contact-email',
    defaultMessage: 'Email',
  },
  notSignedUpContact: {
    id: 'mac.licenses.not.signed.up.contact',
    defaultMessage:
      "This contact has not been signed up. Please enter the contact's first name and last name and we will send out their new user credentials via email",
  },
  contactsLimitReached: {
    id: 'mac.licenses.contacts.limit.reached',
    defaultMessage:
      'Sorry, you have reached the maximum number of contacts allowed. To add a new contact, please delete an existing contact first.',
  },
  addNewContact: {
    id: 'mac.licenses.add.new.contact',
    defaultMessage: 'Add new contact',
  },
  addNewContactModalCancel: {
    id: 'mac.licenses.add.new.contact.modal.cancel',
    defaultMessage: 'Cancel',
  },
  addNewContactModalSave: {
    id: 'mac.licenses.add.new.contact.modal.save',
    defaultMessage: 'Save',
  },
  delete: {
    id: 'mac.licenses.delete',
    defaultMessage: 'Delete',
  },
  unableToDelete: {
    id: 'mac.licenses.unable.to.delete',
    defaultMessage: 'Unable to remove contact',
  },
  errorOnDelete: {
    id: 'mac.licenses.error.on.delete',
    defaultMessage:
      'Action could not be performed. Please refresh the page and try again. Additional information: {error}',
  },
  noneProvided: {
    id: 'mac.update.card.none.provided',
    defaultMessage: 'None provided',
  },
  productTableTitle: {
    id: 'mac.update.card.product',
    defaultMessage: 'Product',
  },
  nameTableTitle: {
    id: 'mac.update.card.name',
    defaultMessage: 'Name',
  },
  renewsOnTableTitle: {
    id: 'mac.update.card.renews.on',
    defaultMessage: 'Renews On',
  },
  estimatedPriceTableTitle: {
    id: 'mac.update.card.estimated.price',
    defaultMessage: 'Estimated price',
  },
  currentPaymentMethodTableTitle: {
    id: 'mac.update.card.current.payment.method',
    defaultMessage: 'Current Payment Method',
  },
  unableToCalculateRenewal: {
    id: 'mac.update.card.renewal.total.error.message',
    defaultMessage:
      'We are currently unable to calculate your renewal total. Please, <contactUs>contact us</contactUs>.',
  },
  estimatedPriceTooltipText: {
    id: 'mac.update.card.estimated.price.tooltip.text',
    defaultMessage: 'This estimate is based on your current users and apps, excluding tax.',
  },
  notNamedYet: {
    id: 'mac.update.card.not.named.yet',
    defaultMessage: 'Not named yet',
  },
  promotionIrreconcilable: {
    id: 'mac.licenses.promotion.irreconcilable',
    defaultMessage:
      'Cannot set primary contact: contact country and account currency are incompatible. Please <link>contact us</link> to update your details.',
  },
  promotionFailed: {
    id: 'mac.licenses.promotion.failed',
    defaultMessage: 'Cannot set primary contact due to internal error.',
  },
  promotingTitle: {
    id: 'mac.licenses.promotion.title',
    defaultMessage: 'Promote {whom} to primary {kind} contact?',
  },
  promoteYourself: {
    id: 'mac.licenses.promote.yourself',
    defaultMessage: '{email} will no longer be primary {kind} contact',
  },
  promoteOther: {
    id: 'mac.licenses.promote.other',
    defaultMessage: "You're about to make {email} the primary {kind} contact on {accountId}",
  },
  promotionAbility: {
    id: 'mac.licenses.promotion.ability',
    defaultMessage: 'This means {person} will be able to:',
  },
  selfPromotionPrivilege1: {
    id: 'mac.licenses.promotion.self.privilege1',
    defaultMessage: 'Access orders and invoices',
  },
  selfPromotionPrivilege2: {
    id: 'mac.licenses.promotion.self.privilege2',
    defaultMessage: 'Promote other users to primary contact',
  },
  promotionPrivilege1: {
    id: 'mac.licenses.promotion.privilege1',
    defaultMessage: 'Access any invoices for this product via email or through My Atlassian',
  },
  promotionPrivilege2: {
    id: 'mac.licenses.promotion.privilege2',
    defaultMessage: 'Promote other contacts to primary in the future.',
  },
  promotionLose: {
    id: 'mac.licenses.promotion.lose',
    defaultMessage:
      '{email} will lose these privileges, but keep the privileges of a non-primary {kind} contact.',
  },
  promotionPastInvoices: {
    id: 'mac.licenses.promotion.past-invoices',
    defaultMessage:
      'Past invoices will not be transferred and will remain in your My Atlassian account under Orders.',
  },
  promotionNotification: {
    id: 'mac.licenses.promotion.notification',
    defaultMessage: 'A notification email will be sent to {email}.',
  },
  promotionConfirm: {
    id: 'mac.licenses.promotion.confirm',
    defaultMessage: 'Yes',
  },
  promotionCancel: {
    id: 'mac.licenses.promotion.cancel',
    defaultMessage: 'Cancel',
  },
  makePrimaryYou: {
    id: 'mac.licenses.make.primary.you',
    defaultMessage: 'you',
  },
  makePrimaryThey: {
    id: 'mac.licenses.make.primary.they',
    defaultMessage: 'they',
  },
  makePrimaryYourself: {
    id: 'mac.licenses.make.primary.yourself',
    defaultMessage: 'yourself',
  },
  serverIdPageTitle: {
    id: 'mac.server-id-page.title',
    defaultMessage: 'Update Server ID',
  },
  serverIdPageSubtitle: {
    id: 'mac.server-id-page.subtitle',
    defaultMessage:
      'To view your license key, the Server ID of your {productDescription}  instance needs to be associated with this license. Please enter the Server ID below - you will only need to do this once:',
  },
  productLabel: {
    id: 'mac.server-id-page.product',
    defaultMessage: 'Product',
  },
  instancelabel: {
    id: 'mac.server-id-page.instance',
    defaultMessage: 'Your instance is',
  },
  upAndRunningInstance: {
    id: 'mac.server-id-page.running.instance',
    defaultMessage: 'up and running',
  },
  notInstalledYetInstance: {
    id: 'mac.server-id-page.not.installed.instance',
    defaultMessage: 'not installed yet',
  },
  serverIdLabel: {
    id: 'mac.server-id-page.server.id',
    defaultMessage: 'Server ID',
  },
  getServerId: {
    id: 'mac.server-id-page.get.server.id',
    defaultMessage: 'To get your Server ID:',
  },
  instructionLine1: {
    id: 'mac.server-id-page.get.instructionLine1',
    defaultMessage: 'Log in as a JIRA administrator',
  },
  instructionLine2: {
    id: 'mac.server-id-page.get.instructionLine2',
    defaultMessage: 'Click on the Settings icon and choose System',
  },
  instructionLine3: {
    id: 'mac.server-id-page.get.instructionLine3',
    defaultMessage: 'Click on the System info link',
  },
  instructionLine4: {
    id: 'mac.server-id-page.instructionLine4',
    defaultMessage: 'Your Server ID is listed in the JIRA info section',
  },
  instructionNotInstalledInstance: {
    id: 'mac.server-id-page.instruction.not.installed',
    defaultMessage:
      'You can locate your Server ID on the {licenseCta} screen in the JIRA setup wizard.',
  },
  instructionNotInstalledInstanceCTA: {
    id: 'mac.server-id-page.instruction.not.installed.cta',
    defaultMessage: 'Specify your license key',
  },
  cantFindServerId: {
    id: 'mac.server-id-page.cant.find.server.id',
    defaultMessage: "Can't find server ID?",
  },
  invalidServerIdTitle: {
    id: 'mac.server-id-page.invalid.server.id.title',
    defaultMessage: 'Invalid Server ID',
  },
  invalidServerIdMessage: {
    id: 'mac.server-id-page.invalid.server.id.message',
    defaultMessage: 'Please try copying and pasting the Server ID directly from the product.',
  },
  unauthorisedMessage: {
    id: 'mac.server-id-page.unauthorised.message',
    defaultMessage: 'You are not authorised to access this product',
  },
  successfullyUpdatedSid: {
    id: 'mac.server-id-page.successfully.updated.sid.message',
    defaultMessage: 'Server ID successfully updated!',
  },
  generateLicenseButtonMessage: {
    id: 'mac.license.evaluation.generate.license',
    defaultMessage: 'Generate License',
  },
  licenseEvaluationPageTitle: {
    id: 'mac.license.evaluation.page.title',
    defaultMessage: 'New Trial License',
  },
  addonLicenseViewPageTitle: {
    id: 'mac.license.addon.view.page.title',
    defaultMessage: 'Getting started with your new app',
  },
  addonLicenseKeyInfoTitle: {
    id: 'mac.license.addon.view.key.info.title',
    defaultMessage: '1. Copy your license key to the clipboard:',
  },

  addonDownloadAppTitle: {
    id: 'mac.license.addon.view.download.app.title',
    defaultMessage: '2. Download app',
  },
  addonInstallAppTitle: {
    id: 'mac.license.addon.view.install.app.title',
    defaultMessage: '3. Install app',
  },
  addonApplyLicenseTitle: {
    id: 'mac.license.addon.view.apply.license.title',
    defaultMessage: '4. Apply your license',
  },
  addonDownloadButtonText: {
    id: 'mac.license.addon.download.button.text',
    defaultMessage: 'Download',
  },
  addonNoteText: {
    id: 'mac.license.addon.view.install.app.note.text',
    defaultMessage: 'Note:',
  },
  addonInstallOpen: {
    id: 'mac.license.addon.view.install.open',
    defaultMessage: 'Open your Atlassian application and log in.',
  },
  addonLicenseLearnMore: {
    id: 'mac.license.addon.view.licenses.learn.more',
    defaultMessage: 'Learn more about installing apps »',
  },
  addonLicensesNavigate: {
    id: 'mac.license.addon.view.licenses.navigate',
    defaultMessage:
      'Navigate to the "Manage Apps" page of your instance (the "Install" section in older versions).',
  },
  addonLicensesCopy: {
    id: 'mac.license.addon.view.licenses.copy',
    defaultMessage:
      'Click the app entry and copy and paste the license key into the license box for your app. All done!',
  },
  addonInstallNavigate: {
    id: 'mac.license.addon.view.install.navigate',
    defaultMessage:
      "Navigate to the administration section. You may need to log in again (we're super secure).",
  },
  addonEolError: {
    id: 'mac.license.addon.evaluation.eol.server.error.body',
    defaultMessage:
      'Experience cloud now with seamless migration for efficient collaboration and accelerated innovation. {exploreCloudUrl}',
  },
  addonMaxEvalError: {
    id: 'mac.license.addon.evaluation.max.eval.error.body',
    defaultMessage:
      'We are unable to generate a trial license for {addOnName}. You have reached the maximum number of trial licenses.',
  },
  addonEolExploreCloud: {
    id: 'mac.license.addon.evaluation.eol.explore.clouds',
    defaultMessage: 'Explore cloud',
  },
  addonInstallChose: {
    id: 'mac.license.addon.view.install.chose',
    defaultMessage:
      'Choose "Apps", then navigate to "Manage Apps" (the "Install" section in older versions).',
  },
  addonInstallUpload: {
    id: 'mac.license.addon.view.install.upload',
    defaultMessage: 'Click the "Upload App" link and upload this file..',
  },
  invalidAddonKeyTitle: {
    id: 'mac.license.addon.evaluation.invalid.plugin.key.title',
    defaultMessage: 'The plugin key is invalid',
  },
  disableCloneQuoteHint: {
    id: 'mac.orders.table.table-item.action.clone.disabled',
    defaultMessage:
      "You'll need to generate a new quote - cloning isn't available for this quote as the pricing plan for one or more products on the quote has changed since it was created.",
  },
  invalidAddonKeyDescription: {
    id: 'mac.license.addon.evaluation.contact.message',
    defaultMessage:
      'We are unable to generate a trial license. Please {contactUsLink} if the problem persists.',
  },
  errorServerDetails: {
    id: 'mac.license.evaluation.error.details',
    defaultMessage: 'Failed to generate a New Trial License. {errorDetails}',
  },
  restrictedCountryDescription: {
    id: 'mac.license.addon.evaluation.restricted.country',
    defaultMessage:
      'Please be aware that the {addOnName} app is not available for purchase in {country}. It may be possible to purchase this app through an Atlassian Partner operating in an eligible country. {learnMoreLink}',
  },
  addonMarketplaceTerms: {
    id: 'mac.license.addon.evaluation.marketplace.terms',
    defaultMessage:
      'I have read and agreed to the <termsOfUseLink>Terms of Use</termsOfUseLink> for the Atlassian Marketplace',
  },
  addonVendorTerms: {
    id: 'mac.license.addon.evaluation.vendor.terms',
    defaultMessage:
      'I have read and agreed to the <termsOfUseLink>Terms of Use</termsOfUseLink> for the {vendorName}',
  },
  restrictedCountryLearnMore: {
    id: 'mac.license.addon.evaluation.restricted.country.learn.more',
    defaultMessage: 'Learn more',
  },
  licenseEvaluationSupportInfo: {
    id: 'mac.license.evaluation.support',
    defaultMessage: 'Please note we only provide trial support for 90 days per product.',
  },
  licenseEvaluationDescription: {
    id: 'mac.license.evaluation.description',
    defaultMessage: 'Everything with server plus:',
  },
  billingTipLine1: {
    id: 'mac.licenses.billing.tip.line1',
    defaultMessage:
      'Billing contacts have access to this license, are contacted with invoicing or billing enquiries, and can raise support requests.',
  },
  billingTipLine2: {
    id: 'mac.licenses.billing.tip.line2',
    defaultMessage:
      'Only the primary contact can access orders and invoices, and promote other users to be primary contact.',
  },
  billingTipLine3: {
    id: 'mac.licenses.billing.tip.line3',
    defaultMessage: 'Non-primary contacts can promote themselves to be primary.',
  },
  partnerDiscountBanner: {
    id: 'mac.partners.discount.banner',
    defaultMessage:
      'Atlassian and Marketplace apps: Apps will follow the same discount rate as their parent products. However, this discount will be capped at 20% and will apply to both new and upgrade orders.',
  },
  discountTitle: {
    id: 'mac.discounts.title',
    defaultMessage: 'Discount',
  },
  discountDescription: {
    id: 'mac.discounts.description',
    defaultMessage: 'Description',
  },
  discountRate: {
    id: 'mac.discounts.rate',
    defaultMessage: 'Rate',
  },
  partnerContacts: {
    id: 'mac.partners.contacts',
    defaultMessage: 'Contacts',
  },
  partnerAddContact: {
    id: 'mac.partners.add.contact',
    defaultMessage: 'Add contact',
  },
  partnerProfileTab: {
    id: 'mac.partners.profile.tab',
    defaultMessage: 'Partner profile',
  },
  emailConfigurationTab: {
    id: 'mac.partners.email.configuration',
    defaultMessage: 'Email Configuration',
  },
  makeSecondary: {
    id: 'mac.partners.make.secondary',
    defaultMessage: 'Make Secondary',
  },
  makeMain: {
    id: 'mac.partners.make.main',
    defaultMessage: 'Make Main',
  },
  contactsTableContact: {
    id: 'mac.partners.contact.table.contact',
    defaultMessage: 'Contact',
  },
  contactsTableEmail: {
    id: 'mac.partners.contact.table.email',
    defaultMessage: 'Email',
  },
  contactsTableContactType: {
    id: 'mac.partners.contact.table.contact.type',
    defaultMessage: 'Contact Type*',
  },
  contactsTableOperations: {
    id: 'mac.partners.contact.table.operations',
    defaultMessage: 'Operations',
  },
  emailTableTimeframe: {
    id: 'mac.partners.email.table.timeframe',
    defaultMessage: 'Timeframe',
  },
  emailTableEmail: {
    id: 'mac.partners.email.table.email',
    defaultMessage: 'Email',
  },
  emailTableRecipients: {
    id: 'mac.partners.email.table.recipients',
    defaultMessage: 'Recipients',
  },
  contactsTableSubText: {
    id: 'mac.partners.contact.sub.text',
    defaultMessage:
      '*Main contacts receive automatically created quotes for expiring licenses from Atlassian. If a partner has no main contacts, all contacts receive these quotes.',
  },
  contactsRemove: {
    id: 'mac.partners.contact.remove',
    defaultMessage: 'Remove',
  },
  contactsMain: {
    id: 'mac.partners.contact.main',
    defaultMessage: 'Main',
  },
  contactsSecondary: {
    id: 'mac.partners.contact.secondary',
    defaultMessage: 'Secondary',
  },
  searchTip: {
    id: 'mac.licenses.search.tip',
    defaultMessage:
      'If you are not seeing the license you are searching for, try searching by another field. If you are still not seeing the license then it may have been renewed or upgraded by another third party; therefore it is no longer available for renewal or upgrade.',
  },
  switchUserBanner: {
    id: 'mac.switch-user.info-banner',
    defaultMessage: 'This features allows Atlassian employees to log in as any MAC user.',
  },
  switchUserInputLabel: {
    id: 'mac.switch-user.input-label',
    defaultMessage: 'Log in as this email address:',
  },
  switchUserButtonUpdate: {
    id: 'mac.switch-user.button.update',
    defaultMessage: 'Update',
  },
  switchUserButtonRevert: {
    id: 'mac.switch-user.button.revert',
    defaultMessage: 'Revert to your own account',
  },
  switchUserNotExistingEmail: {
    id: 'mac.switch-user.validation.not-existing-email',
    defaultMessage:
      'We are unable to locate an Atlassian Account for this user. Please try another email address.',
  },
  licenseEvaluationHostedServerTermsAgreement: {
    id: 'mac.license.evaluation.hosted.server.terms.agree',
    defaultMessage:
      'By clicking "Generate License" below, you agree to the Atlassian <softwareLicenseAgreementLink>Software License Agreement</softwareLicenseAgreementLink> and <privacyPolicy>Privacy Policy</privacyPolicy>',
  },
  licensesSeeFAQinformation: {
    id: 'mac.licenses.see.faq.information',
    defaultMessage: 'For questions on purchasing and licensing, see <link>our FAQs</link>',
  },
  licensesVisitSupportInformation: {
    id: 'mac.licenses.visit-support.information',
    defaultMessage:
      'To find helpful resources on using our products and services, visit <link>Atlassian Support</link>',
  },
  licensesInformationMarketplace: {
    id: 'mac.licenses.information.marketplace',
    defaultMessage:
      'For support with a product app, check its listing details on <link>Atlassian Marketplace</link>',
  },
  licensesGotMoreQuestions: {
    id: 'mac.licenses.more-questions',
    defaultMessage: 'Got more questions? <link>Contact us</link>',
  },
  licensesCollapseAll: {
    id: 'mac.licenses.table.collapse-all',
    defaultMessage: 'Collapse all',
  },
  ordersModalClose: {
    id: 'mac.orders.table.table-item.action.delete-modal.default.close',
    defaultMessage: 'Close',
  },
  ordersModalDeleteText: {
    id: 'mac.orders.table.table-item.action.delete-modal.default.text',
    defaultMessage: 'Are you sure? Deleting a quote cannot be undone.',
  },
  ordersModalDelete: {
    id: 'mac.orders.table.table-item.action.delete-modal.default.delete',
    defaultMessage: 'Delete',
  },
  ordersModalDeleteTitle: {
    id: 'mac.orders.table.table-item.action.delete-modal.default.title',
    defaultMessage: 'Delete Quote',
  },
  paidInvoiceItemTooltip: {
    id: 'mac.invoices.table.table-item.paid-status.tooltip.text',
    defaultMessage:
      'The nominated contacts listed on the invoice can manage and access any applicable license keys via their <link>My Atlassian</link> account.',
  },
  refundedItemToolTip: {
    id: 'mac.invoices.table.table-item.refunded-status.tooltip.text',
    defaultMessage:
      'This order has been refunded. Please contact us at sales@atlassian.com for more information.',
  },
  partiallyRefundedItemTooltip: {
    id: 'mac.invoices.table.table-item.partially-refunded-status.tooltip.text',
    defaultMessage:
      'Part of this order has been refunded. Please contact us at sales@atlassian.com for more information.',
  },
  nonDefaultItemTooltip: {
    id: 'mac.invoices.table.table-item.other-status.tooltip.text',
    defaultMessage: 'Please contact us at sales@atlassian.com for the status of this order.',
  },
  macMainHeader: {
    id: 'mac.main.header',
    defaultMessage: 'My Atlassian',
  },
  macMainSwitchedUserBanner: {
    id: 'mac.main.switched-user.banner',
    defaultMessage:
      'You are currently logged in as {switchedUserEmail}. Any changes you make will be permanently applied to this account.',
  },
  migrationCloudsBanner: {
    id: 'mac.main.migration-clouds.banner',
    defaultMessage:
      'Atlassian will begin mandatory <cloudSiteMigrations>cloud site migrations</cloudSiteMigrations> for all Partners starting on <date>October 16, 2024</date>. To view migrated subscriptions or make billing updates, please login to the <ppcLink>Partner Purchasing Center</ppcLink>.',
  },
  ordersLookupInfoText: {
    id: 'mac.orders.lookup.info.text',
    defaultMessage:
      'You can check the status, update the purchase order number or download a PDF copy of an order by providing us with the following information:',
  },
  ordersLookupFieldsNotCompleted: {
    id: 'mac.orders.lookup.order.fields.not.completed',
    defaultMessage: 'Please complete all fields',
  },
  ordersLookupFieldsNotNumber: {
    id: 'mac.orders.lookup.order.total.is.not.number',
    defaultMessage: 'Total needs to be a number',
  },
  partnerOrderNotFound: {
    id: 'mac.orders.partner.lookup.order.not.found',
    defaultMessage:
      'Unable to locate order. For orders or invoices that contain subscriptions on the new billing engine, use the <ppcLink>Partner Purchasing Center</ppcLink>.',
  },
  orderNotFound: {
    id: 'mac.orders.lookup.order.not.found',
    defaultMessage: 'Unable to locate order',
  },
  orderMatchError: {
    id: 'mac.orders.lookup.order.match.error',
    defaultMessage:
      'The information provided does not match the order. Please reach out to us through our <contactLink>contact forms</contactLink> or have a look at our <faqLink>FAQ</faqLink>. If you are an Atlassian Partner, please check out our <partnerPortalLink>Partner Portal</partnerPortalLink>.',
  },
  orderPoNone: {
    id: 'mac.orders.table.table-item.expanded.po-number.none',
    defaultMessage: 'None',
  },
  filteringLicenses: {
    id: 'mac.licenses.filtering.licenses',
    defaultMessage: 'Licenses',
  },
  filteringLicensesTrial: {
    id: 'mac.licenses.filtering.trial',
    defaultMessage: 'Trial',
  },
  filteringLicensesArchived: {
    id: 'mac.licenses.filtering.archived',
    defaultMessage: 'Archived',
  },
  evaluationOnDemandLine1: {
    id: 'mac.license.evaluation.description.ondemand.line1',
    defaultMessage: 'Let Atlassian host, set up, secure, and maintain your products in the cloud.',
  },
  evaluationOnDemandLine2: {
    id: 'mac.license.evaluation.description.ondemand.line2',
    defaultMessage: 'Get immediate access to the latest features without having to upgrade.',
  },
  evaluationOnDemandLine3: {
    id: 'mac.license.evaluation.description.ondemand.line3',
    defaultMessage:
      'Enjoy end-to-end data protection and privacy protection with industry best-practices such as GDPR and Privacy Shield.',
  },
  evaluationServerLine1: {
    id: 'mac.license.evaluation.description.server.default.line1',
    defaultMessage: 'Manage the entire application on your own servers or virtual machines.',
  },
  evaluationServerLine2: {
    id: 'mac.license.evaluation.description.server.default.line2',
    defaultMessage: 'Deployable to a single server.',
  },
  evaluationJiraSoftwareDataCenterLine1: {
    id: 'mac.license.evaluation.description.jira-software.data-center.line1',
    defaultMessage: 'Active-active clustering for true high availability and uninterrupted access.',
  },
  evaluationJiraSoftwareDataCenterLine2: {
    id: 'mac.license.evaluation.description.jira-software.data-center.line2',
    defaultMessage: 'High performance under high load and at peak times.',
  },
  evaluationJiraSoftwareDataCenterLine3: {
    id: 'mac.license.evaluation.description.jira-software.data-center.line3',
    defaultMessage: 'Disaster recovery.',
  },
  evaluationBambooDataCenterLine1: {
    id: 'mac.license.evaluation.description.bamboo-data-center.line1',
    defaultMessage: 'Improved build resilience',
  },
  evaluationBambooDataCenterLine2: {
    id: 'mac.license.evaluation.description.bamboo-data-center.line2',
    defaultMessage: 'High availability (cold standby setup)',
  },
  evaluationBambooDataCenterLine3: {
    id: 'mac.license.evaluation.description.bamboo-data-center.line3',
    defaultMessage: 'Project level build resources',
  },
  evaluationConfluenceDataCenterLine1: {
    id: 'mac.license.evaluation.description.confluence-data-center.line1',
    defaultMessage: 'Active-active clustering for true high availability and uninterrupted access.',
  },
  evaluationConfluenceDataCenterLine2: {
    id: 'mac.license.evaluation.description.confluence-data-center.line2',
    defaultMessage: 'High performance under high load and at peak times.',
  },
  evaluationConfluenceDataCenterLine3: {
    id: 'mac.license.evaluation.description.confluence-data-center.line3',
    defaultMessage: 'Disaster recovery.',
  },
  evaluationJiraServiceDeskDataCenterLine1: {
    id: 'mac.license.evaluation.description.jira-servicedesk.data-center.line1',
    defaultMessage: 'Active-active clustering for true high availability and uninterrupted access.',
  },
  evaluationJiraServiceDeskDataCenterLine2: {
    id: 'mac.license.evaluation.description.jira-servicedesk.data-center.line2',
    defaultMessage: 'High performance under high load and at peak times.',
  },
  evaluationJiraServiceDeskDataCenterLine3: {
    id: 'mac.license.evaluation.description.jira-servicedesk.data-center.line3',
    defaultMessage: 'Disaster recovery.',
  },
  evaluationStashDataCenterLine1: {
    id: 'mac.license.evaluation.description.stash-data-center.data-center.line1',
    defaultMessage: 'Active-active clustering for true high availability and uninterrupted access.',
  },
  evaluationStashDataCenterLine2: {
    id: 'mac.license.evaluation.description.stash-data-center.data-center.line2',
    defaultMessage: 'High performance under high load and at peak times.',
  },
  evaluationStashDataCenterLine3: {
    id: 'mac.license.evaluation.description.stash-data-center.data-center.line3',
    defaultMessage: 'Disaster recovery.',
  },
  evaluationCrowdDataCenterLine1: {
    id: 'mac.license.evaluation.description.crowd.data-center.line1',
    defaultMessage: 'Active-active clustering for high availability.',
  },
  evaluationCrowdDataCenterLine2: {
    id: 'mac.license.evaluation.description.crowd.data-center.line2',
    defaultMessage: 'Define multiple failover directories for uninterrupted access.',
  },
  evaluationCrowdDataCenterLine3: {
    id: 'mac.license.evaluation.description.crowd.data-center.line3',
    defaultMessage: '',
  },
  ordersNoItems: {
    id: 'mac.orders.table.no-items.message',
    defaultMessage:
      'There are no quotes associated with this account. To find an existing quote, use the Order Lookup tool below.',
  },
  invoicesNotFound: {
    id: 'mac.orders.tabs.invoices.not.found',
    defaultMessage:
      'There are no invoices associated with this account. To find an existing invoice, use the Order Lookup tool below.',
  },
  ordersSingleQuote: {
    id: 'mac.orders.table.single-quote.message',
    defaultMessage: 'You are currently viewing a single quote.',
  },
  ordersSingleQuoteLink: {
    id: 'mac.orders.table.single-quote.link',
    defaultMessage: 'View all quotes that you are associated with.',
  },
  ordersSingleInvoice: {
    id: 'mac.invoices.table.single-invoice.message',
    defaultMessage: 'You are currently viewing a single invoice.',
  },
  ordersSingleInvoiceLink: {
    id: 'mac.invoices.table.single-invoice.link',
    defaultMessage: 'View all invoices that you are associated with.',
  },
  noPermissionsToSeeDetails: {
    id: 'mac.licenses.no.permissions.to.see.details',
    defaultMessage: "You don't have permissions to see the details",
  },
  organizationDetails: {
    id: 'mac.licenses.organization.details',
    defaultMessage: 'Organization Details',
  },
  emailConfigTabDescription: {
    id: 'mac.partners.email.configuration.description',
    defaultMessage:
      'Atlassian sends out emails to Partners and their customers at various stages in the lifecycle of an order or a license. You can configure recipients of some of these emails here.',
  },
  reviewRequired: {
    id: 'mac.partners.email.configuration.review.required.timeframe',
    defaultMessage: 'Quote Received',
  },
  paymentProcessed: {
    id: 'mac.partners.email.configuration.payment.processed.timeframe',
    defaultMessage: 'Payment Processed',
  },
  kittyPartnerTimeFrame: {
    id: 'mac.partners.email.configuration.kitty.partner.timeframe',
    defaultMessage: '{daysCount} days before license expiry',
  },
  kittyCustomerNotificationTimeFrame: {
    id: 'mac.partners.email.configuration.kitty.partner.customer.timeframe',
    defaultMessage: '30 days before license expiry',
  },
  postPurchaseTwoWeeks: {
    id: 'mac.partners.email.configuration.kitty.post.two.weeks.timeframe',
    defaultMessage: '2 weeks post-purchase',
  },
  postPurchaseSevenMonths: {
    id: 'mac.partners.email.configuration.kitty.post.seven.months.timeframe',
    defaultMessage: '7 months post-purchase',
  },
  invoiceWithPdf: {
    id: 'mac.partners.email.configuration.invoice.with.pdf.description',
    defaultMessage: 'Invoice with pdf attached',
  },
  licenseDetails: {
    id: 'mac.partners.email.configuration.license.details.description',
    defaultMessage: 'License details',
  },
  pendingReview: {
    id: 'mac.partners.email.configuration.pending.review.description',
    defaultMessage: 'Quote held pending review (if required)',
  },
  customerReminderForExpiring: {
    id: 'mac.partners.email.configuration.reminder.customer.expiring.description',
    defaultMessage: 'Reminder for expiring licences for a customer',
  },
  reminderForExpiring: {
    id: 'mac.partners.email.configuration.reminder.expiring.description',
    defaultMessage: 'Reminder for expiring licences',
  },
  helpfulResources: {
    id: 'mac.partners.email.configuration.helpful.resources.description',
    defaultMessage: 'Helpful resources',
  },
  confirmationCustomerDetails: {
    id: 'mac.partners.email.configuration.confirmation.customer.details.description',
    defaultMessage: 'Confirmation of current customer details',
  },
  billingContactOrInvoiceRecipient: {
    id: 'mac.partners.email.configuration.billing.contact.or.invoice.recipient',
    defaultMessage: 'Billing Contact on Invoice',
  },
  partnerContactsRecipient: {
    id: 'mac.partners.email.configuration.partner.contacts.recipient',
    defaultMessage: 'Partner contacts',
  },
  allContactsRecipient: {
    id: 'mac.partners.email.configuration.all.contacts.recipient',
    defaultMessage: 'All Technical and Billing Contacts on License',
  },
  reviewRequiredRecipient: {
    id: 'mac.partners.email.configuration.review.required.recipient',
    defaultMessage: 'Billing Contact on Quote',
  },
  licenseCustomerOption: {
    id: 'mac.partners.email.configuration.license.customer.option',
    defaultMessage: 'Customer: Technical, Billing and Purchaser Contacts on Invoice',
  },
  allContactsCustomerOption: {
    id: 'mac.partners.email.configuration.all.contacts.customer.option',
    defaultMessage: 'Customer: All Technical and Billing Contacts on License',
  },
  allTechnicalContactsCustomerOption: {
    id: 'mac.partners.email.configuration.all.technical.contacts.customer.option',
    defaultMessage: 'Customer: All Technical Contacts on License',
  },
  customerCCPartnerContactsOption: {
    id: 'mac.partners.email.configuration.customer.and.cc.partner.contacts.option',
    defaultMessage: 'Customer, and cc partner contacts',
  },
  customerBCCPartnerContactsOption: {
    id: 'mac.partners.email.configuration.customer.and.bcc.partner.contacts.option',
    defaultMessage: 'Customer, and bcc partner contacts',
  },
  partnerOnlyOption: {
    id: 'mac.partners.email.configuration.partner.only.option',
    defaultMessage: 'Partner contacts only',
  },
  thisEmail: {
    id: 'mac.partners.email.configuration.this.email.option',
    defaultMessage: 'This email address:',
  },
  emailConfigSaveBtn: {
    id: 'mac.partners.email.configuration.save.button.text',
    defaultMessage: 'Save',
  },
  emailConfigError: {
    id: 'mac.partners.email.configuration.server.error.description',
    defaultMessage: 'An error occurred while processing request. Try again in a little bit.',
  },
  buy: {
    id: 'mac.licenses.buy',
    defaultMessage: 'Buy',
  },
  expiryDate: {
    id: 'mac.auto-renew.page.expiry-date',
    defaultMessage: 'Expiry Date',
  },
  resultsPerPage: {
    id: 'mac.orders.results.per.page',
    defaultMessage: 'Results per page:',
  },
  quoteUnderReviewTooltip: {
    id: 'mac.orders.table.table-item.quote-status.under-review.tooltip',
    defaultMessage:
      'This order is being reviewed by an Atlassian team member. We will be in touch with you via email shortly.',
  },
  nonDefaultOrderStatusTooltip: {
    id: 'mac.orders.table.table-item.quote-status.non-default.tooltip',
    defaultMessage: 'Please contact us at sales@atlassian.com for the status of this order.',
  },
  downloadSourcePageTitle: {
    id: 'mac.download.source.title',
    defaultMessage: 'Source Downloads',
  },
  downloadSourceNonAtlassianUserError: {
    id: 'mac.download.source.error.non-atlassian-user',
    defaultMessage:
      'The product you requested is not available. Please <contactLink>contact us</contactLink> if you have any questions about accessing the source code.',
  },
  downloadSourceLicensePeriod: {
    id: 'mac.download.source.license.period.text',
    defaultMessage:
      'Your license entitles you to the {product} source for the period of your license.',
  },
  downloadSourceDoNotDistribute: {
    id: 'mac.download.source.do.not.distribute',
    defaultMessage: 'Do not distribute source files.',
  },
  downloadSourceBetaDeveloperReleasesText: {
    id: 'mac.download.source.beta.developer.releases-text',
    defaultMessage:
      'Source may not be provided for {product1} beta releases, developer releases or release candidates, as these are not considered a stable base on which to build extensions or customisations. If you have some special requirement for the source-code of some {product2} version not listed on this page, please <contactUs>contact us</contactUs> directly.',
  },
  downloadSourceQuestionsInfo: {
    id: 'mac.download.source.questions.info',
    defaultMessage:
      "If you have any questions about the source or its architecture, please visit <atlassianAnswersLink>Atlassian Answers</atlassianAnswersLink>. If you have any questions about licensing, please <askUsLink>ask us</askUsLink>. We're only too happy to help you out.",
  },
  noSourceDownloads: {
    id: 'mac.download.source.no.source.downloads.text',
    defaultMessage:
      'There are currently no source downloads available for your license. Please <contactLink>contact us</contactLink> for further details.',
  },
  downloadSourceVersion: {
    id: 'mac.download.source.version',
    defaultMessage: 'Version',
  },
  downloadSourceSize: {
    id: 'mac.download.source.size',
    defaultMessage: 'Size',
  },
  downloadSourceAdded: {
    id: 'mac.download.source.added',
    defaultMessage: 'Added',
  },
  downloadSourceFormat: {
    id: 'mac.download.source.format',
    defaultMessage: 'Format',
  },
  installedOn: {
    id: 'mac.dc.app.coupling.installed.on',
    defaultMessage: 'Installed On',
  },
  cloudReadModeDescription: {
    id: 'mac.cloud-read-mode.message.description',
    defaultMessage:
      "We're migrating cloud sites to our new billing engine. All sites in the old system are in read-only mode. <askUsLink>Contact us</askUsLink> for support with sites in old system. Our team will assist with any changes and in migrating your cloud site to the new billing system. <FAQsLink>Billing engine FAQs</FAQsLink>",
  },
  searchButton: {
    id: 'mac.dc.app.coupling.search.btn',
    defaultMessage: 'Search',
  },
  linkButton: {
    id: 'mac.dc.app.coupling.link.btn',
    defaultMessage: 'Link',
  },
  appParentSENTooltip: {
    id: 'mac.dc.app.coupling.parent.sen.tooltip',
    defaultMessage: 'SEN of the Atlassian app where this Marketplace app is installed',
  },
});

export const getDefaultMessageById = (id: string) => {
  return Object.values(messages)
    .filter((message) => message.id === id)
    .map((message) => message.defaultMessage)
    .pop();
};
